import { useRfqRowView } from '@paradigm/features/src/unified-rfqs/contexts/rfq-row-view';
import { Cell } from '#/components/rfq-common/TableRow';

export const LastTradeCell = () => {
  const { lastTrade } = useRfqRowView();
  return (
    <Cell area="last" role="cell" data-testid="last">
      {lastTrade.formatted}
    </Cell>
  );
};

export const CreationTimeCell = () => {
  const { createdAt } = useRfqRowView();
  return (
    <Cell area="time" role="cell" data-testid="creation-time">
      {createdAt.formatted}
    </Cell>
  );
};
